import { gql } from "@apollo/client"

const GET_WORK_BY_ID = gql`
  query WorkById($id: String!) {
    workCollection(where: { sys: { id: $id } }, limit: 1) {
      items {
        order
        title
        description
        roleOne
        roleTwo
        serviceWorkCollection {
          items {
            sys {
              id
            }
            serviceList
          }
        }
        profileImg {
          url
          title
          description
        }
        heroMedia {
          url
          title
          description
        }
        imgOne {
          url
          title
          description
        }
        imgOneBorderBottom
        imgOneColorRef

        imgTwo {
          url
          title
          description
        }
        imgTwoBorderBottom
        imgTwoColorRef
        imgThree {
          url
          title
          description
        }
        imgThreeBorderBottom
        imgThreeColorRef
        imgFour {
          url
          title
          description
        }
        imgFourBorderBottom
        imgFourColorRef
        imgFive {
          url
          title
          description
        }
        imgFiveBorderBottom
        imgFiveColorRef
        imgSix {
          url
          title
          description
        }
        imgSixBorderBottom
        imgSixColorRef
        imgSeven {
          url
          title
          description
        }
        imgSevenBorderBottom
        imgSevenColorRef
        imgEight {
          url
          title
          description
        }
        imgEightBorderBottom
        imgEightColorRef
        imgNine {
          url
          title
          description
        }
        imgNineBorderBottom
        imgNineColorRef
        imgTen {
          url
          title
          description
        }
        imgTenBorderBottom
        imgTenColorRef
        imgEleven {
          url
          title
          description
        }
        imgElevenBorderBottom
        imgElevenColorRef
        imgTwelve {
          url
          title
          description
        }
        imgTwelveBorderBottom
        imgTwelveColorRef

        primaryColor
        secondaryColor
        tertiaryColor
        introTextColor
      }
    }
  }
`

export default GET_WORK_BY_ID
